import dates from "@/services/date";
import { i18n } from '@/locales';

const invoicePayment = function(invoice) {
  const credit = invoice.price_excluding_vat < 0;
  let result = invoice.status;
  switch (invoice.status) {
    case 'paid':
      result = 'Paid';
      break;
    case 'offset':
      result = 'Offset';
      break;
    case 'pending':
      result = 'Pending';
      break;
    case 'writeoff':
      result = 'Writeoff';
      break;
    case 'unpaid':
      result = (credit) ? 'Credit' : invoiceDue(invoice);
      break;
  }
  return result;
}

const invoiceDue = function(invoice) {
  const dueDate = new Date(invoice.due_date);
  const now = new Date();
  if (dueDate < now) {
    return i18n.t('Overdue');
  } else {
    const timePeriod = dates.timeToNow(dueDate);
    return `Due in ${timePeriod}`;
  }
}

export default {
  install: function (Vue) {
    Vue.filter('invoicePayment', invoicePayment);
  }
}
